export default __webpack_public_path__ + "static/media/readImage.ee12cdf3.png";